export default function titleCase(str) {
    let newStr = str?.replace(/_/g, " ");
    if (!newStr) return;
    newStr = newStr?.toLowerCase();
    newStr = newStr?.split(" ");
    for (var i = 0; i < newStr.length; i++) {
      newStr[i] = newStr[i].charAt(0).toUpperCase() + newStr[i].slice(1);
    }
    return newStr.join(" ");
  }